import React, { useState } from 'react';
import { Mail, MapPin, Send, MessageCircle, CheckCircle } from 'lucide-react';
import './ContactUs.css';

const ContactUs = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsLoading(true);
    
    // Simulate form submission
    setTimeout(() => {
      setIsLoading(false);
      setIsSubmitted(true);
      setFormData({ name: '', email: '', phone: '', message: '' });
    }, 1500);
  };

  const contactInfo = [
    {
      icon: <Mail size={24} />,
      title: 'ای میل',
      value: 'info@amalapp.xyz',
      link: 'mailto:info@amalapp.xyz'
    },
    {
      icon: <MapPin size={24} />,
      title: 'پتہ',
      value: 'اسلام آباد، پاکستان',
      link: null
    }
  ];

  return (
    <div className="contact-page">
      {/* Hero Section */}
      <div className="page-hero">
        <div className="container">
          <div className="hero-icon">
            <MessageCircle size={48} />
          </div>
          <h1>رابطہ کریں</h1>
          <p>کوئی سوال ہے؟ ہم آپ کی مدد کے لیے حاضر ہیں</p>
        </div>
      </div>

      {/* Content */}
      <div className="contact-content">
        <div className="container">
          <div className="contact-grid">
            {/* Contact Form */}
            <div className="contact-form-wrapper">
              <div className="form-header">
                <h2>ہمیں پیغام بھیجیں</h2>
                <p>اپنا سوال یا رائے ہمیں بھیجیں، ہم جلد جواب دیں گے</p>
              </div>

              {isSubmitted ? (
                <div className="success-message">
                  <div className="success-icon">
                    <CheckCircle size={48} />
                  </div>
                  <h3>شکریہ!</h3>
                  <p>آپ کا پیغام موصول ہو گیا ہے۔ ہم جلد آپ سے رابطہ کریں گے۔</p>
                  <button 
                    className="btn btn-outline"
                    onClick={() => setIsSubmitted(false)}
                  >
                    نیا پیغام بھیجیں
                  </button>
                </div>
              ) : (
                <form onSubmit={handleSubmit} className="contact-form">
                  <div className="form-group">
                    <label htmlFor="name">نام *</label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      placeholder="اپنا نام لکھیں"
                      required
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="email">ای میل *</label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      placeholder="اپنا ای میل لکھیں"
                      required
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="phone">فون نمبر</label>
                    <input
                      type="tel"
                      id="phone"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      placeholder="اپنا فون نمبر لکھیں"
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="message">پیغام *</label>
                    <textarea
                      id="message"
                      name="message"
                      value={formData.message}
                      onChange={handleChange}
                      placeholder="اپنا پیغام یہاں لکھیں..."
                      rows="5"
                      required
                    ></textarea>
                  </div>

                  <button 
                    type="submit" 
                    className={`btn btn-primary btn-submit ${isLoading ? 'loading' : ''}`}
                    disabled={isLoading}
                  >
                    {isLoading ? (
                      <span className="loader"></span>
                    ) : (
                      <>
                        <Send size={20} />
                        پیغام بھیجیں
                      </>
                    )}
                  </button>
                </form>
              )}
            </div>

            {/* Contact Info */}
            <div className="contact-info-wrapper">
              <div className="info-header">
                <h2>رابطے کی معلومات</h2>
                <p>ہم سے رابطہ کرنے کے مختلف طریقے</p>
              </div>

              <div className="contact-cards">
                {contactInfo.map((info, index) => (
                  <div className="contact-card" key={index}>
                    <div className="card-icon">
                      {info.icon}
                    </div>
                    <div className="card-content">
                      <h4>{info.title}</h4>
                      {info.link ? (
                        <a href={info.link} style={{ direction: 'ltr', display: 'inline-block', unicodeBidi: 'embed' }}>{info.value}</a>
                      ) : (
                        <span>{info.value}</span>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
